class Sustainability {
  groups: any[] = [
    {
      name: '40',
      title: 'Varor & material',
      accounts: '40-45, 47, 49',
      questions: [
        {
          order: 1,
          header: 'Var produceras era varor/ert material?',
          text: 'Har ni identifierat risker kring leverantörskedjan (t ex kring klimat, mänskliga rättigheter) och arbetar ni aktivt med kontroll och efterlevnad? Kontroll och efterlevnad handlar om att göra uppföljning på att leverantören eller underentreprenören uppfyller de krav man ställer samt att de inte förlorat något tillstånd eller certifikat under avtalets gång.',
        },
        {
          order: 2,
          header: 'Har ni gjort en kartläggning över er affärsmodell?',
          text: 'Har ni gjort en kartläggning över er affärsmodell och vilka resurser ni är beroende av för att bedriva verksamheten?',
        },
        {
          order: 3,
          header: 'Har ni diskuterat möjligheterna till en cirkulär affärsmodell?',
          text: 'En cirkulär affärsmodell handlar om att använda, och återanvända, våra resurser på ett smartare sätt. Hur kan företaget återanvända resurser, minimera spill och kanske till och med se på sitt erbjudande som en tjänst snarare än en produkt? Kan ni hyra ut istället för att sälja? En viktig fråga är vem som ansvarar för produkten efter den utjänade tiden?',
        },
        {
          order: 4,
          header: 'Har ni en säker resurstillförsel och kan driva er verksamhet på samma sätt i 10 år till?',
          text: 'Är ni beroende av ändliga resurser, ex. olja, trä och vatten till era produkter eller ert material?',
        },
        {
          order: 5,
          header: 'Går det att komplettera försäljning av tjänster i kombination med varor?',
          text: 'Känner ni till vilka produkter som socialt och miljömässigt påverkar mest negativt? Har ni mycket spill i produktionen? Har ni frågat era kunder vad som är viktigt för dem? Hur arbetar era konkurrenter? Hur informerar ni om ursprung, innehåll och hur varan/emballage ska tas om hand?',
        },
      ],
      kpi: ['Andel av förnybara resurser i livscykeln, andel bytbara resurser/material, andel resurser producerat av fossila bränslen/förnybara energikällor, andel resurser vars tillgång hotas inom kommande 10 åren, varornas uppskattade livslängd, andel av inköpt material som kan återanvändas'],
    },
    {
      name: '46',
      title: 'Underentreprenörer',
      accounts: '46',
      questions: [
        {
          order: 1,
          header: 'Har ni en uppförandekod?',
          text: 'Dokument som förklarar hur ni ser på mänskliga rättigheter, antikorruption, arbetsmiljö samt miljö. Och hur ni förväntar er att era underentreprenörer agerar när de utför arbete åt er.',
        },
        {
          order: 2,
          header: 'Hur jobbar ni med era underentreprenörer?',
          text: 'Vilka avtal följer ni och hur säkerställer ni att dessa följer era riktlinjer?',
        },
        {
          order: 3,
          header: 'Hur arbetar ni med frågor så som affärsetik, mutor, korruption, penningtvätt, jämställdhet, sexuella trakasserier, avfallshantering, vattenanvändning hos era leverantörer/underentreprenörer?',
          text: '',
        },
        {
          order: 4,
          header: 'Har ni identifierat era risker kring leverantörskedjan?',
          text: 'Har ni identifierat era risker kring leverantörskedjan (t ex kring klimat och mänskliga rättigheter) och arbetar ni aktivt med kontroll och efterlevnad? Kontroll och efterlevnad handlar om att göra uppföljning på att leverantören eller underentreprenören uppfyller de krav man ställer samt att de inte förlorat något tillstånd eller certificat under avtalets gång.',
        },
      ],
      kpi: ['Koldioxidutsläpp/vattenanvändning/energianvändning scope 3, antal anställda i leverantörskedjan, antal inrapporterade olycksfall i leverantörskedjan, antal fall mot mänskliga rättigheter i leverantörskedjan, antal visselblåsarfall under hela livscykeln, andel granskade leverantörer, andel underleverantörer i högriskländer, andel underleverantörer i högriskbranscher'],
    },
    {
      name: '50',
      title: 'Lokaler',
      accounts: '50',
      questions: [
        {
          order: 1,
          header: 'Är era lokaler miljöcertifierade?',
          text: 'T.ex. BREEAM, ISO? Gäller hyrda såväl som egna lokaler. Är det egna lokaler kan kunden ställa dessa krav innan det byggs.',
        },
        {
          order: 2,
          header: 'Mäter ni aspekter så som energi- och vattenanvändning i era ägda eller hyrda lokaler?',
          text: '',
        },
        {
          order: 3,
          header: 'Har ni gjort en bedömning avseende arbetsmiljösäkerhet i era lokaler?',
          text: '',
        },
      ],
      kpi: ['Antal miljöcertifierade fastigheter, årlig utveckling av vattenanvändning/energianvändning/avfall från era fastigheter, andel av fossila/förnybara energikällor i byggnaden, procentuell återvinning/återanvändning av materialet i bygganderna, antal risker med fastigheterna (vattenläckor, värmeförluster etc), energiintensiteten i fastigheterna'],
    },
    {
      name: '51',
      title: 'Fastighetskostnader',
      accounts: '51',
      questions: [
        {
          order: 1,
          header: 'Har ni identifierat besparingspotential för fastighetskostnader kopplat till miljöaspekter så som minskad energianvändning, vattenanvändning, miljöcertifieringar etc.? ',
          text: '',
        },
        {
          order: 2,
          header: 'Hur samarbetare ni med er fastighetsägare kring miljöfrågor?',
          text: 'Hur samarbetare ni med er fastighetsägare kring miljöfrågor? Grönt avtal? Hur arbetar ni med avfall och spill?',
        },
        {
          order: 3,
          header: 'Planerar ni några om-, ny eller tillbyggnader?',
          text: 'Planerar ni några om-, ny eller tillbyggnader alternativt reparation och underhåll? Finns miljöaspekterna med i dessa beslut?',
        },
        {
          order: 4,
          header: 'Hur arbetar ni med era leverantörer kring hållbarhetsfrågor?',
          text: 'Hur arbetar ni med era leverantörer kring hållbarhetsfrågor t ex kring miljö och arbetsvillkor? Hur säkerställer ni att dessa följer era riktlinjer.',
        },
      ],
      kpi: ['Antal fastigheter med renoveringsbehov och deras uppskattade kostnader, kostnadsbesparingar med passiv/energieffektiva hus, avkastning på gröna obligationer'],
    },
    {
      name: '52',
      title: 'Hyra av anläggningstillgångar',
      accounts: '52',
      questions: [
        {
          order: 1,
          header: 'Hur samarbetar ni med er fastighetsägare kring miljöfrågor?',
          text: 'Hur samarbetare ni med er fastighetsägare kring miljöfrågor? Grönt avtal? Hur arbetar ni med avfall och spill?',
        },
        {
          order: 2,
          header: 'Har ni några riktlinjer t ex vad gäller leasingbilar och personalbilar?',
          text: '',
        },
      ],
      kpi: ['Potentiella samarbeten med intressenter för gröna projekt (lägre ränta)'],
    },
    {
      name: '53',
      title: 'Energi',
      accounts: '53',
      questions: [
        {
          order: 1,
          header: 'Vad har ni för energi?',
          text: 'Vad har ni för energi? Förnybar, fossilfritt, icke fossilfritt?',
        },
        {
          order: 2,
          header: 'Hur samlar ni in information om och rapporterar er energianvändning i dagsläget?',
          text: '',
        },
        {
          order: 3,
          header: 'Har ni satt mål för att minska energianvändningen?',
          text: '',
        },
        {
          order: 4,
          header: 'Hur samarbetar ni med er fastighetsägare kring miljöfrågor?',
          text: 'Hur samarbetare ni med er fastighetsägare kring miljöfrågor? Grönt avtal? Hur arbetar ni med avfall och spill?',
        },
      ],
      kpi: ['Energianvändning i scope 1 & 2 (vilken typ av energi används och hur mycket), alternativa energikällor i samtliga led i produktionen, kostnadsbesparingar vid energibyte, möjligheten att bli självförsörjande (investera i solceller etc)'],
    },
    {
      name: '54',
      title: 'Förbrukningsmaterial',
      accounts: '54',
      questions: [
        {
          order: 1,
          header: 'Vet ni vad er största kostnad avseende förbrukningsmaterial består av?',
          text: '',
        },
        {
          order: 2,
          header: 'Hur arbetar ni för att minska förbrukningsmaterial?',
          text: '',
        },
        {
          order: 3,
          header: 'Har ni diskuterat möjligheterna till en cirkulär affärsmodell?',
          text: 'En cirkulär affärsmodell handlar om att använda, och återanvända, våra resurser på ett smartare sätt. Hur kan företaget återanvända resurser, minimera spill och kanske till och med se på sitt erbjudande som en tjänst snarare än en produkt? Kan vi hyra ut istället för att sälja? En viktig fråga är vem som ansvarar för produkten efter den utjänade tiden? Hur återvinns den?',
        },
      ],
      kpi: ['Mängd i kg av engångsartiklar, andel återvunnet material, andel återanvänt material, mängd ofarligt/farligt avfall, alternativa material för förbrukningsartiklar'],
    },
    {
      name: '55',
      title: 'Reparation & underhåll',
      accounts: '55',
      questions: [
        {
          order: 1,
          header: 'Hur tar ni hänsyn till hållbarhet när det kommer till reparationer?',
          text: '',
        },
        {
          order: 2,
          header: 'Har ni diskuterat möjligheterna till en cirkulär affärsmodell?',
          text: 'En cirkulär affärsmodell handlar om att använda, och återanvända, våra resurser på ett smartare sätt. Hur kan företaget återanvända resurser, minimera spill och kanske till och med se på sitt erbjudande som en tjänst snarare än en produkt? Kan vi hyra ut istället för att sälja? En viktig fråga är vem som ansvarar för produkten efter den utjänade tiden?',
        },
        {
          order: 3,
          header: 'Är det enkelt för kunden att välja reparation istället för att köpa nytt?',
          text: '',
        },
      ],
      kpi: ['Årlig utveckling av antal reperationer, jämförelser av livslängd med andra material, andel återvunnet material vid reperationer, andel återanvänt material vid reperationer'],
    },
    {
      name: '56',
      title: 'Transportmedel',
      accounts: '56',
      questions: [
        {
          order: 1,
          header: 'Vad använder ni för drivmedel?',
          text: '',
        },
        {
          order: 2,
          header: 'Har ni en hållbarhets-/miljöpolicy för transportmedel i leverantörsledet?',
          text: '',
        },
        {
          order: 3,
          header: 'Har ni en tjänstebilspolicy?',
          text: 'Har ni riktlinjer för att medarbetare ska köra el- eller hybridbilar?',
        },
      ],
      kpi: ['Årlig utveckling av antal tjänsteresor, antal tjänsteresor per fordonstyp (flyg, tåg, bil) , antal inrikesresor, antal utrikesresor, antal digitala möten, antal fysiska möten med potential att digitaliseras, antal egna tjänstebilar/andra fordon, andel av fordon som drivs på förnybara bränslen '],
    },
    {
      name: '57',
      title: 'Frakter & transport',
      accounts: '57',
      questions: [
        {
          order: 1,
          header: 'Vad använder era leverantörer för transportmedel?',
          text: 'Vet ni vilket drivmedel de använder?',
        },
        {
          order: 2,
          header: 'Har ni identifierat era risker kring frakter och transport?',
          text: 'Arbetar ni aktivt med kontroll och efterlevnad? Kontroll och efterlevnad handlar om att göra uppföljning på att leverantören eller underentreprenören uppfyller de krav man ställer samt att de inte förlorat något tillstånd eller certificat under avtalets gång.',
        },
        {
          order: 3,
          header: 'Hur sätter ni mål för att minska er miljöpåverkan från frakter och transporter?',
          text: '',
        },
        {
          order: 4,
          header: 'Hur kan ni samarbeta/ställa högre krav/välja leverantörer som erbjuder hållbar transport?',
          text: 'Har ni satt ett mål?',
        },
        {
          order: 5,
          header: 'Vilka krav ställer ni avseende arbetsvillkor hos transportörer?',
          text: 'Vilka avtal följer ni och hur säkerställer ni att dessa följer era riktlinjer?',
        },
      ],
      kpi: ['Andel miljöcertifierade transporter/åkerier, utsläpp från transporter i leverantörskedjan, antal transporter per fordonstyp (flyg, bil, tåg), antal underleverantörer inblandad i transportkedjan'],
    },
    {
      name: '58',
      title: 'Resor',
      accounts: '58',
      questions: [
        {
          order: 1,
          header: 'Vad består era tjänsteresor av?',
          text: 'Flyg, tåg, bil?',
        },
        {
          order: 2,
          header: 'Hur arbetar ni för att minska antalet resor i arbetet? ',
          text: '',
        },
        {
          order: 3,
          header: 'Har ni en resepolicy för hur medarbetare ska förhålla sig till resor i arbetet?',
          text: '',
        },
        {
          order: 4,
          header: 'Klimatkompenserar ni för tjänsteresor?',
          text: 'Vissa flygresor är nödvändiga att utföra. Då väljer många bolag att kompensera för vad resorna orsakar i form av utsläpp. Det kan vara till olika klimatprojekt (ex. trädplantering), men man kan även välja att kompensera till olika utecklingsprojekt och innovationer som bidrar till en hållbar utveckling.',
        },
        {
          order: 5,
          header: 'Har ni teknisk utrustning som möjliggör minskade resor?',
          text: 'Finns det ett ledarskap som stöttar flexibilitet och har tillit till digial närvaro? Hur ser era fester och konferenser ut - planeras de utifrån en hållbar inriktning både vid val av resmål/genomförande och mat?',
        },
      ],
      kpi: ['Årlig utveckling av antal tjänsteresor, antal tjänsteresor per fordonstyp (flyg, tåg, bil) , antal inrikesresor, antal utrikesresor, antal digitala möten, antal fysiska möten med potential att digitaliseras, antal egna tjänstebilar/andra fordon, andel av fordon som drivs på förnybara bränslen'],
    },
    {
      name: '59',
      title: 'Reklam & PR',
      accounts: '59',
      questions: [
        {
          order: 1,
          header: 'Hur tänker ni kring hållbarhet när det kommer till reklam & PR?',
          text: 'T.ex. hur mycket trycker ni vs digital reklam? Vid fysisk reklam använder ni till exempel återvunnet papper?',
        },
        {
          order: 2,
          header: 'Kommunicerar ni något om hållbarhet idag?',
          text: 'Känner era intressenter till era långsiktiga mål, vilka värderingar ni som företag har, hur ni arbetar med medarbetare och hur er affär påverkar samhället och miljön?',
        },
        {
          order: 3,
          header: 'Arbetar ni aktivt med er reklambyrå för att minska er miljöpåverkan?',
          text: '',
        },
        {
          order: 4,
          header: 'Skickar eller budar ni reklam eller paket till intressenter?',
          text: 'Vad använder ni då för transportmedel? Har ni identifierat risker och kostnader för detta? ',
        },
        {
          order: 5,
          header: 'Hur kommunicerar ni kring hållbarhet med era intressenter?',
          text: 'Känner era kunder medarbetare, leverantörer till hur ni arbetar med hållbarhet? Vilka kan ni påverka till bra val genom tydlig information och vägledning? Märker ni upp varor som har låg påverkan på miljön?',
        },
      ],
      kpi: ['Antal gröna kampanjer, andel av fysisk vs digital marknadsföring, mängd och typ av material bakom fysisk marknadsföring, siffror på antal nådda konsumenter per marknadsföringsstrategi'],
    },
    {
      name: '60',
      title: 'Övriga försäljningskostnader',
      accounts: '60',
      questions: [
        {
          order: 1,
          header: 'Mäter ni hur stor del av försäljningen som är klassad som hållbar?',
          text: '',
        },
      ],
      kpi: [],
    },
    {
      name: '61',
      title: 'Kontorsmaterial',
      accounts: '61',
      questions: [
        {
          order: 1,
          header: 'Hur arbetar ni för att minska inköp av kontorsmaterial?',
          text: '',
        },
        {
          order: 2,
          header: 'Tar er inköpsprocess hänsyn till hållbarhetsfrågor vid inköp av kontorsmaterial?',
          text: '',
        },
      ],
      kpi: ['Andel engångsartiklar, plastanvändning, pappersanvädning, % av material återvunnet, årlig utveckling av materialanvändning, klimatpåverkan (Scope 1, 2, 3) av sponsorprodukter'],
    },
    {
      name: '62',
      title: 'Tele & post',
      accounts: '62',
      questions: [
        {
          order: 1,
          header: 'Har ni en miljö- eller hållbarhetspolicy/strategi?',
          text: 'Täcker den tele & post?',
        },
        {
          order: 2,
          header: 'Mäter ni eller har ni information om klimatpåverkan för era försändelser?',
          text: '',
        },
        {
          order: 3,
          header: 'Hur stor påverkan har tele & post på ert hållbarhetsarbete jämfört med andra aspekter?',
          text: '',
        },
        {
          order: 4,
          header: 'Hur arbetar ni med datasäkerhet? ',
          text: '',
        },
      ],
      kpi: ['Utsläpp från posttransporter, typ av transportmedel (post)'],
    },
    {
      name: '63',
      title: 'Försäkringar & riskhantering',
      accounts: '63',
      questions: [
        {
          order: 1,
          header: 'Har ni utfört en riskanalys kopplat till miljö- och klimatrisker?',
          text: '',
        },
        {
          order: 2,
          header: 'Har ni identifierat hållbarhetsrisker som kan påverka bolagets försäkringar?',
          text: '',
        },
        {
          order: 3,
          header: 'Har ni leverantörer/fastigheter/andra tillgångar som kan komma till skada till följd av klimatförändringarna?',
          text: '',
        },
        {
          order: 4,
          header: 'Finns det en risk att ni inte kan attrahera nya medarbetare?',
          text: 'Vilka risker finns med er affärsmodell 5 år framåt?',
        },
      ],
      kpi: ['TCFD beräkningar'],
    },
    {
      name: '64',
      title: 'Förvaltning',
      accounts: '64',
      questions: [],
    },
    {
      name: '65',
      title: 'Övriga externa tjänster',
      accounts: '65',
      questions: [],
    },
    {
      name: '68',
      title: 'Inhyrd personal',
      accounts: '68',
      questions: [
        {
          order: 1,
          header: 'Hur arbetar ni med att förebygga sjukfrånvaro, olyckor, och att utveckla inhyrd personal?',
          text: '',
        },
        {
          order: 2,
          header: 'Hur arbetar ni med mänskliga rättigheter, arbetstimmar, jämställdhet etc. för inhyrd personal?',
          text: '',
        },
        {
          order: 3,
          header: 'Måste inhyrd personal läsa/skriva på er uppförandekod om en sådan finns?',
          text: 'Om ja, hur följer ni upp att man följer era riktlinjer?',
        },
      ],
      kpi: ['Minimumlön samt arbetsvillkor för inhyrd personal, kön & ålder på inhyrd personal, antal inrapporterade fall från inhyrd personal'],
    },
    {
      name: '69',
      title: 'Övriga externa kostnader',
      accounts: '69',
      questions: [
        {
          order: 1,
          header: 'Hur sätter ni mål för att förbättra och effektivisera er verksamhet?',
          text: '',
        },
        {
          order: 2,
          header: 'Hur undvikerna ni att få böter för t ex miljöbrott?',
          text: '',
        },
        {
          order: 3,
          header: 'Har ni identifierat hur mycket avfall ni har i er verksamhet?',
          text: 'Restavfall i produktionen, svinn osv?',
        },
      ],
      kpi: ['Kg avfall/omsatt krona'],
    },
    {
      name: '70',
      title: 'Medarbetare',
      accounts: '70-73, 76',
      questions: [
        {
          order: 1,
          header: 'Hur jobbar ni med att utveckla era medarbetare?',
          text: 'Medarbetare utgör en viktig del av ert värdeskapande, hur arbetar ni med att förebygga sjukfrånvaro, olyckor, personalomsättning och att utveckla era medarbetare? ',
        },
        {
          order: 2,
          header: 'Har ni en uppförandekod/arbetsmiljöpolicy?',
          text: '',
        },
        {
          order: 3,
          header: 'Hur mycket kan era anställda om miljöpåverkan i samband med era produkter och tjänster?',
          text: 'Investerar ni i utbildning för medarbetare inom dessa områden?',
        },
        {
          order: 4,
          header: 'Hur ser långtids- och korttidssjukrivningen ut?',
          text: 'Har ni hög/låg (ökande eller minskande) sjukfrånvaro? Vad kostar det er per år? Hur arbetar ni med ledarskap och vidareutveckling? Hur arbetar ni med jämlikhet och jämställdhet? Hur arbetar ni med mångfald? Hur fångar ni upp diskriminering? Finns det ett visselblåsarsystem?',
        },
        {
          order: 5,
          header: 'Hur arbetar ni med arbetssätt/förmåner som skapar förutsättningar för hälsosam livsstil t ex ersättning för träning?',
          text: '',
        },
      ],
      kpi: ['Personalomsättning, könsfördelning per befattning, antal kvinnor i ledande positioner, frisknärvaro, sjukfrånvaro, antal nationaliteter bland de anställda, arbetsrelaterad sjukfrånvaro, antal visselblåsarfall/inrapporterade fall, åldersfördelning bland personalen'],
    },
    {
      name: '74',
      title: 'Pensioner',
      accounts: '74',
      questions: [
        {
          order: 1,
          header: 'Har ni som arbetsgivare koll på vilka fonder som personalens pensioner investeras i?',
          text: '',
        },
        {
          order: 2,
          header: 'Har ni en miljöpolicy för pensionssparande?',
          text: '',
        },
        {
          order: 3,
          header: 'Har medarbetare möjlighet att välja de fonder som passar deras värden för att spara för sin pension? ',
          text: '',
        },
      ],
      kpi: [],
    },
    {
      name: '75',
      title: 'Skatter',
      accounts: '75, 89',
      questions: [
        {
          order: 1,
          header: 'Har ni rätt stöd för att hantera och betala rätt skatt i de länder ni verkar i? ',
          text: '',
        },
      ],
      kpi: ['Skattelättnader vid produktion av mer hållbara slutprodukter?'],
    },
  ];
}

export default new Sustainability();
